<template>
  <jw-modal v-model:visible="showWEditor" title-align="start" width="60%" @ok="handelOk" @cancel="handleCancel" :mask-closable="false">
    <template #title>富文本编辑</template>
    <w-editor ref="inputRef" v-model="fieldValue" :configs="{ height: 500 }"></w-editor>
  </jw-modal>
</template>
<script setup>
import { ref, watch } from 'vue';
import { tools } from '@/utils/tools.js';
import { Message } from '@arco-design/web-vue';
const props = defineProps({
  modelValue: String,
  isRequired: Boolean
});
const emits = defineEmits(['cb', 'change']);
const showWEditor = ref(false);
const fieldValue = ref(props.modelValue);
watch(
  () => fieldValue.value,
  (newVal) => {
    emits('change', newVal);
  }
);
const isNoText = (textValue) => {
  if (!textValue || (!tools.handleRichText(textValue) && props.isRequired)) return true;
  return false;
};
const handelOk = () => {
  if (isNoText(fieldValue)) {
    //必填校验
    Message.warning('必填字段不能为空!');
    return;
  }
  // 富文本空值处理
  if (fieldValue.value === '<p><br></p>') {
    fieldValue.value = '';
  }
  emits('cb', { type: 'ok', value: fieldValue.value });
};

const handleCancel = () => {
  showWEditor.value = false;
  emits('cb', { type: 'cancel' });
};

const openDialog = (record) => {
  fieldValue.value = record.fieldValue;
  showWEditor.value = true;
};
defineExpose({
  openDialog
});
</script>
